import axios from 'axios';
import * as actionTypes from '../constants/actions';
import baseUrl from '../utils/baseUrl';

function receiveData(type, key, json) {
	return {
		type: type,
		key: key,
		payload: json,
	};
};

function receiveError(json) {
	return {
		type: actionTypes.RECV_ERROR,
		payload: json,
	};
};

function fetchGeneric(url, type, key = false, cb = () => {}) {
	return function(dispatch) {
		return axios({
			url: url,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
		})
		.then(function(response) {
			if (key && response.data[key]) {
				dispatch(receiveData(type, key, response.data[key]));
			} else {
				dispatch(receiveData(type, key, response.data));
			}

			cb(true);
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));

			//dispatch(pushState(null, '/error'));
			cb(false);
		});
	};
}

function fetchSingle(url) {
	return fetchGeneric(url, actionTypes.ACCOUNT_RECV_SINGLE);
};

function fetchCollection(url, key, cb) {
	return fetchGeneric(url, actionTypes.ACCOUNT_RECV_COLLECTION, key, cb);
};

export function fetchUserEditorials(type, cb) {
	return fetchCollection(baseUrl + '/api/account/editorials/' + type, 'editorials', cb);
}

export function fetchProfileEditorials(type, cb) {
	return fetchCollection(baseUrl + '/api/account/profiles/editorials/' + type, 'editorials', cb);
}

export function fetchCases(cb = () => {}) {
	return fetchCollection(baseUrl + '/api/account/profiles/cases', 'cases', cb);
}

export function clearCollection() {
	return { type: actionTypes.ACCOUNT_CLEAR_COLLECTION };
}

export function clearSingle() {
	return { type: actionTypes.ACCOUNT_CLEAR_SINGLE };
}



/** WEBPACK FOOTER **
 ** ./frontend/actions/account.js
 **/